export default {
  Support: {
    Call: {
      Title: 'اطلاعات تماس پشتیبان',
      SelectTemplate: 'انتخاب پیام آماده',
    },
    Sms: {
      Title: 'ارسال پیام به پشتیبان',
      MessageText: 'متن پیام',
      MoreCases: 'سایر موارد',
    },
  },
}
